// DOM ids used as the onboarding-tour anchors of the notifications: the bell and, below `sm`, the
// avatar. Shared between the component that renders each id and the tour step that targets it,
// the same contract as `navTourAnchors`. Only one of the desktop and mobile headers is mounted at
// a time, so one id covers both.
export const NOTIFICATION_TOUR_ANCHORS = {
  bell: 'onboarding-notification-bell',
  avatar: 'onboarding-notification-avatar',
} as const;
